import { render, staticRenderFns } from "./LinkedTickets.vue?vue&type=template&id=25572607&scoped=true&"
import script from "./LinkedTickets.vue?vue&type=script&lang=js&"
export * from "./LinkedTickets.vue?vue&type=script&lang=js&"
import style0 from "./LinkedTickets.vue?vue&type=style&index=0&id=25572607&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25572607",
  null
  
)

export default component.exports